/* eslint-disable id-length */
jQuery(document).ready(($) => {
  $('[data-toggle="popover"]').popover({
    placement: 'top',
    trigger: 'hover',
  });
});
